const addClickEventToContactWidgetOpener = () => {
  document.querySelectorAll(".contactWidgetOpener-newMessage").forEach((el) => {
    el.addEventListener("click", () => {
      window.zE("webWidget", "open");
    });
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", addClickEventToContactWidgetOpener);
} else {
  addClickEventToContactWidgetOpener();
}
